// extracted by mini-css-extract-plugin
module.exports = {"varSpUp1":"1.25rem","content":"content--b8446","imageBox":"imageBox--bae8b","fieldContainer":"fieldContainer--74c4f"};